import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithErrorHandling } from './baseQuery';

export type MatterFlattenedContext = Record<string, string | null>;

export interface GetMatterContextParams {
  matterId: string;
  medicalNoteId?: string;
  coverageId?: string;
  coverage1pId?: string;
  coverage3pId?: string;
  coverageHealthId?: string;
  policeReportId?: string;
  treatmentRecordRequestId?: string;
  treatmentChannelId?: string;
  /** When provided, includes package recipient fields (recipientName, recipientAddress1, etc.) */
  correspondencePackageId?: string;
  /** When provided, swaps the representing attorney in the context */
  attorneyId?: string;
}

export const matterFlattenedContextApi = createApi({
  reducerPath: 'matterFlattenedContextApi',
  baseQuery: baseQueryWithErrorHandling,
  endpoints: (builder) => ({
    getMatterFlattenedContext: builder.query<
      MatterFlattenedContext,
      GetMatterContextParams
    >({
      query: ({
        matterId,
        medicalNoteId,
        coverageId,
        coverage1pId,
        coverage3pId,
        coverageHealthId,
        policeReportId,
        treatmentRecordRequestId,
        treatmentChannelId,
        correspondencePackageId,
        attorneyId,
      }) => {
        const params = new URLSearchParams();
        if (medicalNoteId) params.append('medical_note_id', medicalNoteId);
        if (coverageId) params.append('coverage_id', coverageId);
        if (coverage1pId) params.append('coverage_1p_id', coverage1pId);
        if (coverage3pId) params.append('coverage_3p_id', coverage3pId);
        if (coverageHealthId) params.append('coverage_health_id', coverageHealthId);
        if (policeReportId) params.append('police_report_id', policeReportId);
        if (treatmentRecordRequestId)
          params.append(
            'treatment_record_request_id',
            treatmentRecordRequestId,
          );
        if (treatmentChannelId)
          params.append('treatment_channel_id', treatmentChannelId);
        if (correspondencePackageId)
          params.append('correspondence_package_id', correspondencePackageId);
        if (attorneyId) params.append('attorney_id', attorneyId);
        return {
          url: `api/matters/${matterId}/context/${params.toString() ? `?${params.toString()}` : ''}`,
        };
      },
    }),
  }),
});

export const { useGetMatterFlattenedContextQuery } = matterFlattenedContextApi;
